import {
    trigger,
    style,
    animate,
    transition
} from '@angular/animations';


export const fadeInOutAnimation = trigger('fadeInOut', [
    transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(800, style({ opacity: 1 }))
    ]),
    transition(':leave', [   // :leave is alias to '* => void'
        animate(800, style({ opacity: 0 }))
    ])
]);
